import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ENTERPRISE_CONTRACT_TERM_OPTIONS,
  ENTERPRISE_MEDIA_MANAGEMENT_ADDON_OPTIONS,
  ENTERPRISE_WHITE_LABEL_OPTIONS,
} from "../../../utils/constants";
import {
  ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT,
  ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND,
  ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_FIELD_WHITE_LABEL,
  ENTERPRISE_INTAKE_HINT_CONTRACT_TERM,
  ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON,
  ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT,
  ENTERPRISE_INTAKE_HINT_WHITE_LABEL,
  ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES,
  ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND,
} from "../../../i18n/keysTranslations";
import FieldBlock from "../../PreActivation/components/FieldBlock";
import FieldLabel from "../../PreActivation/components/FieldLabel";
import IntakeTextField from "../../../components/Form/IntakeTextField";
import ReadOnlySectionGrid from "../../PreActivation/components/ReadOnlySectionGrid";
import NumericFieldBlock from "./shared/NumericFieldBlock";
import RadioFieldBlock from "./shared/RadioFieldBlock";
import { mapTranslatedOptions } from "./shared/mapTranslatedOptions";

const PlanSection = ({
  control,
  errors,
  readOnly,
  showWhiteLabel,
  showMediaManagementAddon,
  showMediaSpend,
}) => {
  const { t } = useTranslation();

  const contractTermOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_CONTRACT_TERM_OPTIONS,
        t,
      }),
    [t]
  );

  const whiteLabelOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_WHITE_LABEL_OPTIONS,
        t,
      }),
    [t]
  );

  const mediaAddonOptions = useMemo(
    () =>
      mapTranslatedOptions({
        options: ENTERPRISE_MEDIA_MANAGEMENT_ADDON_OPTIONS,
        t,
      }),
    [t]
  );

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <NumericFieldBlock
        name="platformUsersCount"
        labelKey={ENTERPRISE_INTAKE_FIELD_PLATFORM_USERS_COUNT}
        hintKey={ENTERPRISE_INTAKE_HINT_PLATFORM_USERS_COUNT}
        required
        min={1}
        control={control}
        errors={errors}
        readOnly={readOnly}
        t={t}
      />

      <RadioFieldBlock
        name="contractTermMonths"
        labelKey={ENTERPRISE_INTAKE_FIELD_CONTRACT_FORMAT}
        hintKey={ENTERPRISE_INTAKE_HINT_CONTRACT_TERM}
        required
        options={contractTermOptions}
        control={control}
        readOnly={readOnly}
      />

      {showWhiteLabel ? (
        <RadioFieldBlock
          name="whiteLabelRequirement"
          labelKey={ENTERPRISE_INTAKE_FIELD_WHITE_LABEL}
          hintKey={ENTERPRISE_INTAKE_HINT_WHITE_LABEL}
          required
          options={whiteLabelOptions}
          control={control}
          readOnly={readOnly}
        />
      ) : null}

      {showMediaManagementAddon ? (
        <RadioFieldBlock
          name="mediaManagementAddon"
          labelKey={ENTERPRISE_INTAKE_FIELD_MEDIA_MANAGEMENT_ADDON}
          hintKey={ENTERPRISE_INTAKE_HINT_MEDIA_MANAGEMENT_ADDON}
          required
          options={mediaAddonOptions}
          control={control}
          readOnly={readOnly}
        />
      ) : null}

      {showMediaSpend ? (
        <NumericFieldBlock
          name="monthlyMediaSpendUsd"
          labelKey={ENTERPRISE_INTAKE_FIELD_MONTHLY_MEDIA_SPEND}
          placeholderKey={ENTERPRISE_INTAKE_PLACEHOLDER_MONTHLY_MEDIA_SPEND}
          required
          min={0}
          control={control}
          errors={errors}
          readOnly={readOnly}
          t={t}
        />
      ) : null}

      <FieldBlock>
        <FieldLabel
          htmlFor="additionalNotes"
          text={t(ENTERPRISE_INTAKE_FIELD_ADDITIONAL_NOTES)}
        />
        <IntakeTextField
          name="additionalNotes"
          control={control}
          rules={{}}
          errors={errors}
          fullWidth
          multiline
          minRows={4}
          readOnly={readOnly}
          placeholder={t(ENTERPRISE_INTAKE_PLACEHOLDER_ADDITIONAL_NOTES)}
          variant="outlined"
        />
      </FieldBlock>
    </ReadOnlySectionGrid>
  );
};

export default PlanSection;
